(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["sr-p01"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const bound = new WeakSet();
    const desktop = window.matchMedia('(min-width: 901px)');

    function bindGalleries(root = document) {
      root.querySelectorAll('#P01 .sr-native-gallery').forEach((gallery) => {
        const media = gallery.querySelector(':scope > .pm--sticky');
        if (!media || bound.has(gallery)) return;
        bound.add(gallery);
        function measure() {
          if (!desktop.matches) {
            gallery.style.removeProperty('--sr-p01-gallery-height');
            return;
          }
          gallery.style.setProperty('--sr-p01-gallery-height', `${media.getBoundingClientRect().height}px`);
        }

        const observer = new ResizeObserver(measure);
        observer.observe(media);
        window.addEventListener('resize', measure, { passive: true });

        function unload(event) {
          if (!event.target.contains(gallery)) return;
          observer.disconnect();
          window.removeEventListener('resize', measure);
          document.removeEventListener('shopify:section:unload', unload);
          bound.delete(gallery);
        }

        document.addEventListener('shopify:section:unload', unload);
        measure();
      });
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', () => bindGalleries(), { once: true });
    } else {
      bindGalleries();
    }
    document.addEventListener('shopify:section:load', (event) => bindGalleries(event.target));
  })();

  if (!customElements.get('sr-offer-countdown')) {
    class SrOfferCountdown extends HTMLElement {
      static deadline(date, time, zone) {
        const dateParts = /^(\d{4})-(\d{2})-(\d{2})$/.exec(date);
        const timeParts = /^(\d{2}):(\d{2})(?::(\d{2}))?$/.exec(time);
        if (!dateParts || !timeParts) return NaN;
        const [year, month, day] = dateParts.slice(1).map(Number);
        const hour = Number(timeParts[1]);
        const minute = Number(timeParts[2]);
        const second = Number(timeParts[3] || 0);
        if (year < 1000 || month < 1 || month > 12 || day < 1 || hour > 23 || minute > 59 || second > 59) return NaN;
        const wall = Date.UTC(year, month - 1, day, hour, minute, second);
        const calendar = new Date(wall);
        if (calendar.getUTCFullYear() !== year || calendar.getUTCMonth() !== month - 1 || calendar.getUTCDate() !== day) return NaN;
        try {
          const formatter = new Intl.DateTimeFormat('en-GB', {
            timeZone: zone,
            year: 'numeric', month: '2-digit', day: '2-digit',
            hour: '2-digit', minute: '2-digit', second: '2-digit',
            hourCycle: 'h23'
          });
          const read = (instant) => {
            const parts = {};
            formatter.formatToParts(new Date(instant)).forEach((part) => {
              if (part.type !== 'literal') parts[part.type] = Number(part.value);
            });
            return Date.UTC(parts.year, parts.month - 1, parts.day, parts.hour, parts.minute, parts.second);
          };
          let instant = wall;
          for (let pass = 0; pass < 4; pass += 1) {
            const correction = wall - read(instant);
            if (correction === 0) return instant;
            instant += correction;
          }
          return read(instant) === wall ? instant : NaN;
        } catch {
          return NaN;
        }
      }

      connectedCallback() {
        clearTimeout(this.timer);
        queueMicrotask(() => {
          if (!this.isConnected) return;
          this.start();
        });
      }

      disconnectedCallback() {
        clearTimeout(this.timer);
      }

      start() {
        const deadline = SrOfferCountdown.deadline(this.dataset.date || '', this.dataset.time || '23:59:59', this.dataset.zone || 'Europe/Paris');
        const valid = Number.isFinite(deadline);
        const note = this.querySelector('[data-countdown-note]');
        if (note) note.hidden = valid;
        this.hidden = !valid && !this.hasAttribute('data-editor');
        if (!valid) return;
        const nodes = {};
        ['days', 'hours', 'minutes', 'seconds'].forEach((unit) => {
          nodes[unit] = this.querySelector(`[data-unit="${unit}"]`);
        });
        const tick = () => {
          if (!this.isConnected) return;
          const total = Math.ceil(Math.max(0, deadline - Date.now()) / 1000);
          const values = {
            days: Math.floor(total / 86400),
            hours: Math.floor(total / 3600) % 24,
            minutes: Math.floor(total / 60) % 60,
            seconds: total % 60
          };
          Object.entries(values).forEach(([unit, value]) => {
            const text = String(value).padStart(2, '0');
            if (nodes[unit] && nodes[unit].textContent !== text) nodes[unit].textContent = text;
          });
          if (total > 0) this.timer = setTimeout(tick, 1000 - (Date.now() % 1000));
        };
        tick();
      }
    }
    customElements.define('sr-offer-countdown', SrOfferCountdown);
  }


  } catch(e) { console.error(e); }
})();
})();
